import './App.css';
import { useEffect, useState } from 'react';
import { useAuth } from './context/AuthContext';
import Login from './login/login';
import Menu from './menu/menu';
import { FaFolder } from "react-icons/fa";
import { FaUserFriends } from "react-icons/fa";
import DataTable from 'react-data-table-component';
import { MdEdit, MdDelete } from "react-icons/md";
import Users from './catalogs/users/users';
import Dashboard from './dashboard/dashboard';
import { api } from './utils/services/api';
import { SERVICE } from './utils/constants/services';
import Catalogos from './catalogs/puestos/catalogs';
import MenuTarget from './menu/menuTarget';
import { ConfigProvider } from 'antd';
import frFR from 'antd/locale/es_ES';
import Coordinadores from './catalogs/coordinadores/coordinadores';
import Sucursales from './catalogs/sucursales/sucursales';
import Asesores from './catalogs/asesores/asesores';
import Clientes from './pretamos/clientes/clientes';
import Avales from './pretamos/avales/avales';
import Distribuidor from './pretamos/distribuidores/distribuidor';
import Compañias from './catalogs/companies/companies';
import Distribuidores from './pretamos/distribuidores/distribuidor';
import CompañiasAF from './catalogs/companiesAf/companiesAf';
import Vales from './pretamos/vales/vales';
import Prestamos from './pretamos/prestamos/prestamos';
import Login2 from './login2/login2';
import Corte from './corte/corte';
import Documentacion from './documentacion/documentacion';
import Pagos from './pretamos/pagos/pagos';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import {jwtDecode} from "jwt-decode"; 
import Swal from 'sweetalert2';
import Metas from './pretamos/metas/metas';
import Holidays from './catalogs/holidays/holidays';
import Reportes from './reportes/reportes';
import AuditLog from './auditlog/auditlog';
import Nomina from './nomina/nomina';
import Rutas from './rutas/rutas';




function App() {
  //contexto
  const { handleLogout,menuActual, setMenuActual, windowSize, setWindowSize,setClientActual,token,setToken } = useAuth();

  //useState
  const [actualComponent, setActualComponent] = useState();

  //Funciones
  
  //useEffect
  useEffect(() => { 
    if(menuActual){
      if(menuActual === "config1"){
        setActualComponent(
          <Users></Users>
        );
      }
      else if(menuActual === "config2"){
        setActualComponent(
          <Catalogos></Catalogos>
        );
      }
      else if(menuActual === "catalog3"){
        setActualComponent(
          <Coordinadores></Coordinadores>
        );
      }
      else if(menuActual === "catalog7"){
        setActualComponent(
          <Sucursales></Sucursales>
        );
      }
      else if(menuActual === "catalog1"){
        setActualComponent(
          <Asesores></Asesores>
        );
      }
      else if(menuActual === "catalog5"){
        setActualComponent(
          <Compañias></Compañias>
        );
      }
      else if(menuActual === "catalog6"){
        setActualComponent(
          <CompañiasAF></CompañiasAF>
        );
      }
      else if(menuActual === "catalog2"){
        setActualComponent(
          <Avales></Avales>
        );
      }
       else if(menuActual === "catalog8"){
        setActualComponent(
          <Holidays></Holidays>
        );
      }
      else if(menuActual.includes("Menu")){
        setActualComponent(
          <MenuTarget></MenuTarget>
        );
      }
      else if(menuActual === "home"){
        setActualComponent(
          <Dashboard></Dashboard>
        );
      }
      else if(menuActual === "prestamo1"){
        setActualComponent(
          <Clientes></Clientes>
        );
      }
      else if(menuActual === "prestamo2"){
        setActualComponent(
          <Prestamos></Prestamos>
        );
      }
      else if(menuActual === "prestamo3"){
        setClientActual(null);
        setActualComponent(
          <Prestamos></Prestamos>
        );
      }
      else if(menuActual === "prestamo4"){
        setActualComponent(
          <Metas></Metas>
        );
      }
      else if(menuActual === "prestamo5"){
        setActualComponent(
          <Nomina></Nomina>
        );
      }
      else if(menuActual === "catalog4"){
        setActualComponent(
          <Distribuidores></Distribuidores>
        );
      }
      else if(menuActual === "vales"){
        setActualComponent(
          <Vales></Vales>
        );
      }
      else if(menuActual === "corte"){
        setActualComponent(
          <Corte></Corte>
        );
      }
      else if(menuActual === "document"){
        setActualComponent(
          <Documentacion></Documentacion>
        );
      }
      else if(menuActual === "pagos"){
        setActualComponent(
          <Pagos></Pagos>
        );
      
      }else if(menuActual === "reportes"){
        setActualComponent(
          <Reportes></Reportes>
        );
      
      }else if(menuActual === "auditlog"){
        setActualComponent(
          <AuditLog></AuditLog>
        );
      
      }
      else if(menuActual === "rutas"){
        setActualComponent(
          <Rutas></Rutas>
        );
      
      }
      else{
        setActualComponent(null);
        setMenuActual(null);
      }
    }
  }, [menuActual])
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    
    return () => window.removeEventListener('resize', handleResize);

    
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          const currentTime = Math.floor(Date.now() / 1000); 

          if (decodedToken.exp && decodedToken.exp < currentTime) {
            Swal.fire({
              title: "Sesión expirada",
              text: "Tu sesión ha expirado. Se cerró la sesión.",
              icon: "warning",
              buttons: true,
              dangerMode: true,
            }).then((result) => {
              if (result.isConfirmed) {
               
              }
            });
            handleLogout();
          }
        } catch (error) {
          console.error("Error al decodificar el token:", error);
          Swal.fire({
            title: "Sesión expirada",
            text: "Tu sesión ha expirado. Se cerró la sesión.",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          }).then((result) => {
            if (result.isConfirmed) {
              
            }
          });
          handleLogout();
        }
      }
    }, 1000);

    return () => clearInterval(interval); 
  }, [token]);
  
  return (
    <>
      {
        (
          menuActual == null ?
            (
              <Login2></Login2>
            )
            :
            (
              
              <div className='containerMain'>
                <Menu></Menu>
                <div className='containerWin' style={{
                  width: windowSize.width,
                  height: windowSize.height
                }}>
                  {actualComponent}
                </div>
              </div>
            )
        )
      }
    </>
  );
}

export default App;
